import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
const propTypes = {
  /**
   * Card select objects
   **/
  children: PropTypes.node.isRequired,
  /**
   * hides the legend from sighted users, but is read out by screen readers
   **/
  hideLegend: PropTypes.bool,
  /**
   * Fieldset legend
   **/
  legend: PropTypes.string.isRequired
};
const defaultProps = {
  hideLegend: false
};
function CardSelectContainer(props) {
  const {
    children,
    legend,
    hideLegend
  } = props;
  const legendClassNames = cx('asc-form-label', {
    'asc-acc-hidden': hideLegend
  });
  return /*#__PURE__*/React.createElement("fieldset", {
    className: "asc-card-select-container asc-form-group"
  }, /*#__PURE__*/React.createElement("legend", {
    className: legendClassNames
  }, /*#__PURE__*/React.createElement("span", null, legend)), children);
}
CardSelectContainer.defaultProps = defaultProps;
CardSelectContainer.propTypes = propTypes;
export default CardSelectContainer;